import React from 'react';
import { Grid, InputLabel } from '@material-ui/core';
import helpers from '../utils/fieldsHelper';
import FieldLabel from './FieldLabel';

var FormField = function FormField(_ref) {
  var label = _ref.label,
      labelPlacement = _ref.labelPlacement,
      labelProps = _ref.labelProps,
      required = _ref.required,
      children = _ref.children;
  var direction = labelPlacement === 'top' ? 'column' : 'row';
  var content = helpers.getHtmlMarkup(label);
  return React.createElement(Grid, {
    container: true,
    direction: direction,
    style: {
      paddingLeft: 15
    }
  }, React.createElement(FieldLabel, {
    label: content,
    labelPlacement: labelPlacement,
    required: required
  }), React.createElement(Grid, {
    item: true,
    xs: labelPlacement === 'top' || !content ? 12 : 8
  }, children));
};

export default React.memo(FormField);